import { gql, DocumentNode } from '@apollo/client';
import { Box, Typography } from '@mui/material';
import React from 'react';
import styles from './InvoiceViewNotes.module.scss';
import { InvoiceViewNotesInvoiceFragment } from '#types';
import classNames from 'classnames';

export const invoiceViewNotesInvoiceFragment = gql`
	fragment invoiceViewNotesInvoice on Invoice {
		id
		notes
	}
`;

export type InvoiceViewNotesProps = {
	invoice?: InvoiceViewNotesInvoiceFragment;
	className?: string;
};

type InvoiceViewNotesPropsWithFragment = React.FC<InvoiceViewNotesProps> & {
	fragments: {
		invoiceViewNotesInvoiceFragment: DocumentNode;
	};
};

export const InvoiceViewNotes: InvoiceViewNotesPropsWithFragment = ( {
	invoice,
	className,
} ) =>
	invoice?.notes ? (
		<Box
			className={ classNames( styles.container, className ) }
			data-cy='invoice-view-notes-container'
		>
			<Typography variant='h6' className={ styles.header }>
				Note
			</Typography>
			<Typography
				data-cy='invoice-view-notes'
				component='div'
				className={ styles.notes }
				dangerouslySetInnerHTML={ { __html: invoice.notes } }
			/>
		</Box>
	) : null;

InvoiceViewNotes.fragments = {
	invoiceViewNotesInvoiceFragment,
};
